import React from 'react';
import Button from "./element/Button";
const img = require('../images/r-pluming-logo.png')


const Navbar = () => {
    return (
        <div>
            <div className="navbar bg-white">
                <div className="navbar-start">
                    <div className="dropdown">
                        <label tabIndex={0} className="btn btn-ghost text-black text-lg font-bold lg:hidden">
                            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"
                                 stroke="currentColor" className="w-6 h-6">
                                <path strokeLinecap="round" strokeLinejoin="round"
                                      d="M3.75 5.25h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5m-16.5 4.5h16.5"/>
                            </svg>

                        </label>
                        <ul tabIndex={0} className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-white rounded-box w-52">
                            <li><a className="text-black text-lg">Home</a></li>
                            <li tabIndex={0}><a className="justify-between text-black text-lg">Our Service</a></li>
                            <li><a className="text-black text-lg">Contact Us</a></li>
                        </ul>
                    </div>
                    <div>
                        <a href="#"><img src={img} className="w-64" alt="r-pluming-logo"/></a>
                    </div>
                </div>
                <div className="navbar-center hidden lg:flex">
                    <ul className="menu menu-horizontal p-0">
                        <li><a className="text-black text-lg">Home</a></li>
                        <li tabIndex={0}><a className="text-black text-lg">Our Service</a></li>
                        <li><a className="text-black text-lg">Contact Us</a></li>
                    </ul>
                </div>
                <div className="navbar-end">
                    <Button text="GET FREE QUOTE" />
                </div>
            </div>
        </div>
    );
};

export default Navbar;
